<template>
  <div class="recharge-platform-box" :style="rechargePlatformBoxStyle" :class="{'isiOSX':isiOSX}">
    <header>
      <span @click="back">
        <img src="../../assets/recharge/back2@2x.png" />
      </span>
      <span>平台充值</span>
    </header>
    <div class="header-fill"></div>

    <div class="input">
      <div>
        <span>产品名称</span>
        <span>{{charge_name}}</span>
      </div>
      <div v-if="!modulesInfo[charge_id].dontShowInput">
        <span>充值账号</span>
        <span>
          <!-- <input type="text" placeholder="请输入手机号" v-model="inputValue" @blur="regPhone"> -->
          <input type="text" 
          :placeholder="modulesInfo[charge_id].placeholder" 
          v-model="inputValue" 
          @blur="verifyAccount"
          @input="onInput"
           />
        </span>
      </div>
    </div>

    <main>
      <h3>面额</h3>
      <div v-if="data.denominations" style="font-weight:bold!important">
        <Member
          v-for="(item,itemKey,index) in data.denominations.data"
          :key="index"
          :list="item"
          :itemKey="itemKey"
          @getitem="getitem"
          :idx="activeidx"
        ></Member>
      </div>

      <div class="count">
        <div>
          优惠价:
          <span>{{ this.btnActive ? getFloat : '0'}}</span>
          <span>元</span>
        </div>
        <div>赠积分: {{ this.btnActive ? Number(activeItem.credits).toFixed(2) : '0.00'}}</div>
      </div>

      <div class="btn" :class="{'btn-active': btnActive}">
        <button @click="submit">确认支付</button>
      </div>

      <div class="tips" v-if="data.description">
        <h4>温馨提示</h4>
        <!-- 6 优酷视频 -->
        <!-- <p v-if="charge_id==6">不能上京东，其他天猫，电商平台</p> -->
        <!-- <p
          v-for="(item,index) in data.description.data"
          :key="index"
        >{{`${index+1}.${item.description}`}}</p> -->
        <p v-for="(item, i) in this.descriptions" :key="i">
          {{ item }}
        </p>

      </div>
    </main>

    <van-dialog
      v-model="showDialog"
      :message="dialogMessage"
      confirm-button-text="去处理"
      confirm-button-color="#F9591B"
      cancel-button-text="取消"
      cancel-button-color="#999999"
      @confirm="goOrderList"
      show-cancel-button
    ></van-dialog>

    <div class="loading" v-if="loading">
      <img src="../../assets/common/loading.gif" />
    </div>
  </div>
</template>

<script>
import Member from "./components/member.vue";
import { Notify } from "vant";
export default {
  data() {
    return {
      isiOSX: false,
      data: {},
      title: "",
      activeItem: {},
      activeidx: 0,
      btnActive: false,
      charge_id: "",
      inputValue: "",
      client: 0,
      modulesInfo: {},
      charge_name: '',
      validateAccount: false,
      Paying: false,
      descriptions: [],
      showDialog: false,
      dialogMessage: '当前有一笔待支付的订单',
      loading: false,
      rechargePlatformBoxStyle: {},

    };
  },
  created() {
    this.isiOSX = this.isIphoneX()
    this.deductionUA()
    // this.$api.setToken(this.token);
    this.charge_id = String(this.$route.query.charge_id)
    this.charge_name = this.$route.query.charge_name
    this.init()
  },
  mounted() {
    if (this.isiOSX) {
      this.$set(this.rechargePlatformBoxStyle, 'max-height', 'calc(100% - 20px)')
      this.$set(this.rechargePlatformBoxStyle, 'position', 'fixed')
      this.$set(this.rechargePlatformBoxStyle, 'top', '0')
      this.$set(this.rechargePlatformBoxStyle, 'left', '0')
      this.$set(this.rechargePlatformBoxStyle, 'overflow-y', 'auto')
      this.$set(this.rechargePlatformBoxStyle, 'box-sizing', 'border-box')
    }
    
  },
  methods: {
    init() {
      this.modulesInfo = {
        // 爱奇艺
        "4": {
          placeholder: "请输入手机号",
          regexp: [/^\d{11}$/],
        },
        // QQ音乐
        "8": {
          placeholder: "请输入QQ号",
          regexp: [/[1-9][0-9]{4,11}/],
          // regexp: [/^\d{11}$/],
        },
        // 网易云音乐
        "9": {
          placeholder: "",
          // regexp: [/.*/],
          dontShowInput: true,
        },
        // Keep
        "13": {
          placeholder: "请输入Keep账号",
          // TODO: keep账号验证规则 手机号
          regexp: [/^\d{11}$/],
        },
        // 酷狗音乐
        "10": {
          // TODO： 手机号规则
          placeholder: "请输入手机号",
          regexp: [/^\d{11}$/],
        },
        // 百度网盘
        "11": {
          placeholder: "",
          // regexp: [/.*/],
          dontShowInput: true,
        },
        // 新浪娱乐
        "12": {
          placeholder: "请输入手机号",
          // TODO: 新浪微博账号验证规则 ，手机号
          regexp: [/^\d{11}$/],
        },
        // 腾讯视频
        "5": {
          placeholder: "请输入QQ号",
          regexp: [/^[1-9][0-9]{4,11}$/],
          // regexp: [/^\d{11}$/],
        },
        // 优酷视频
        "6": {
          placeholder: "请输入手机号",
          regexp: [/^\d{11}$/],
        },
        // 芒果TV
        "7" : {
          placeholder: "请输入绑定的手机号",
          // 多个正则只要一个匹配就OK
          regexp: [/^\d{11}$/],
        },
      };
      this.$api
        .post("thirdrecharge/member/recharge/denomination/list", {
          charge_id: this.charge_id,
        })
        .then((res) => {
          this.data = res;
          // if (res.denominations.data) 
          //   this.activeItem = this.getprop(res.denominations.data)[0];
          // if (res.denominations.data)
          //   this.activeidx = this.getprop(res.denominations.data)[0].id;
          if (res.description.data)
            this.descriptions = res.description.data[0].description.split('\n')
        });
    },
    deductionUA() {
      let ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
        this.client = 11;
      } else if (/android/.test(ua)) {
        this.client = 10;
      }
    },
    verifyAccount() {
      this.validateAccount = this.modulesInfo[this.charge_id].regexp.some(item => {
        return item.test(this.inputValue)
      })
    },
    getitem(obj) {
      this.activeItem = obj.item;
      this.activeidx = obj.index;
      this.data.description.data.forEach(ii => {
        // 这里的条件 面额列表的 key+'充值说明' 等于 description中每一项的title，如果规则有变，修改 
        if (ii.title == `${obj.itemKey}充值说明`) {
          this.descriptions = ii.description.split('\n')
          return
        }
      });
      this.btnActive = true;
    },

    onInput(e) {
      switch (this.charge_id) {
        case '4':
          // 爱奇艺，手机号
          if (this.inputValue.length >= 12) {
            this.inputValue = this.inputValue.slice(0, 11)
          }
          if (this.inputValue.length >= 1 && ! /^\d$/.test(this.inputValue.slice(-1))) {
            this.inputValue = this.inputValue.slice(0, -1)
          }
          break;
        case '8':
          // qq音乐，qq号
          if (this.inputValue.length >= 13) {
            this.inputValue = this.inputValue.slice(0, 12)
          }
          if (this.inputValue.length >= 1 && ! /^\d$/.test(this.inputValue.slice(-1))) {
            this.inputValue = this.inputValue.slice(0, -1)
          }
          break;
        case '13':
          // keep 手机号
          if (this.inputValue.length >= 12) {
            this.inputValue = this.inputValue.slice(0, 11)
          }
          if (this.inputValue.length >= 1 && ! /^\d$/.test(this.inputValue.slice(-1))) {
            this.inputValue = this.inputValue.slice(0, -1)
          }
          break;
        case '10':
          // 酷狗音乐，手机号
          if (this.inputValue.length >= 12) {
            this.inputValue = this.inputValue.slice(0, 11)
          }
          if (this.inputValue.length >= 1 && ! /^\d$/.test(this.inputValue.slice(-1))) {
            this.inputValue = this.inputValue.slice(0, -1)
          }
          break;
        case '12':
          // 新浪微博 手机号
          if (this.inputValue.length >= 12) {
            this.inputValue = this.inputValue.slice(0, 11)
          }
          if (this.inputValue.length >= 1 && ! /^\d$/.test(this.inputValue.slice(-1))) {
            this.inputValue = this.inputValue.slice(0, -1)
          }
          break;
        case '5':
          // 腾讯视频 qq号
          if (this.inputValue.length >= 13) {
            this.inputValue = this.inputValue.slice(0, 12)
          }
          if (this.inputValue.length >= 1 && ! /^\d$/.test(this.inputValue.slice(-1))) {
            this.inputValue = this.inputValue.slice(0, -1)
          }
          break;
        case '6':
          // 优酷视频 手机号
          if (this.inputValue.length >= 12) {
            this.inputValue = this.inputValue.slice(0, 11)
          }
          if (this.inputValue.length >= 1 && ! /^\d$/.test(this.inputValue.slice(-1))) {
            this.inputValue = this.inputValue.slice(0, -1)
          }
          break;
        case '7':
          // 芒果tv 手机号
          if (this.inputValue.length >= 12) {
            this.inputValue = this.inputValue.slice(0, 11)
          }
          if (this.inputValue.length >= 1 && ! /^\d$/.test(this.inputValue.slice(-1))) {
            this.inputValue = this.inputValue.slice(0, -1)
          }
          break;

      }

      // if (/^\d{12}$/.test(this.inputValue)) {
      //   this.inputValue = this.inputValue.slice(0, 11)
      //   this.$toast('请输入相应手机号码')
      // }

    },

    getprop(obj) {
      for (name in obj) {
        return obj[name];
      }
    },
    // 订单列表
    goOrderList() {
      this.$router.replace({
        path: "/recharge/myOrder",
        query: {
          charge_from: 'platform',
        },
      });
    },
    submit() {
      if (! this.btnActive) return
      if (this.Paying) return
      this.Paying = true
      // 验证输入账号 9 网易云音乐 11 百度网盘  这两个没有账号，不需要验证
      if (! this.validateAccount && ! [9, 11].includes(parseInt(this.charge_id))) {
        this.$toast("账号格式不正确")
        this.Paying = false
        return
      }
      // 判断是否是卡密充值（网易云音乐，百度网盘），在确认订单得时候充值账号传入0.
      if(this.charge_id == 11 || this.charge_id == 9) {
        this.inputValue = 0
      }
      //提交
      this.loading = true
      this.$api
        .post("/order/member/order/confirm", {
          order: {
            type: "thirdrecharge_card",
          },
          charge_id: this.charge_id,
          channel_id: this.data.denominations.channel_id,
          goods_id: this.activeItem.id,
          charge_account: this.inputValue,
          charge_amount: this.activeItem.price,
        })
        .then((data) => {
          let confirm = data.order.confirm;
          // 创建订单
          this.$api
            .post("/order/member/order/create", {
              order: {
                type: "thirdrecharge_card",
                client: this.client,
                confirm: confirm,
              },
              charge_id: this.charge_id,
              channel_id: this.data.denominations.channel_id,
              goods_id: this.activeItem.id,
              charge_account: this.inputValue,
              charge_amount: this.activeItem.price,
            })
            .then((data) => {
              let param = {
                actual_amount: data.actual_amount,
                deduct_coin: data.deduct_coin,
                deduct_credits: data.deduct_credits,
                order_amount: data.order_amount,
                ordersn: data.ordersn,
              };
              this.Paying = false
              this.loading = false
              this.params(
                JSON.stringify(param),
                JSON.stringify(param),
                "rechargePay"
              );
            })
            .catch(err => {
              this.Paying = false
              this.loading = false
            })
        })
        .catch(err => {
          if(err.code == 249001){
              this.$toast(err.message)
          }
          this.Paying = false
          this.loading = false
        })
    },
    back() {
      this.$router.go(-1);
    },
  },
  computed: {
    getFloat() {
      return Number(this.activeItem.price).toFixed(2);
    },
  },
  components: {
    Member,
  },
};
</script>

<style lang="less" scoped>
.recharge-platform-box {
  padding-top: 88px;
  width: 100%;
  // height: 100%;
  background-color: #f5f6f7;
  color: #333333;
  // 头部
  header {
    width: 100%;
    height: 44px;
    position: fixed;
    top: 44px;
    z-index: 1;
    background-color: #ffffff;
    span {
      &:nth-of-type(1) {
        position: relative;
        display: inline-block;
        width: 18px;
        height: 100%;
        padding: 0 16px;
        font-weight: bold!important;
        img {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          display: inline-block;
          width: 16px;
          height: 16px;
        }
      }
      &:nth-of-type(2) {
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 18px;
        font-weight: bold!important;
      }
    }
  }
  .header-fill {
    position: fixed;
    top: 0;
    height: 0;
    padding-top: 44px;
    width: 100%;
    background-color: #ffffff;
  }
  //输入框
  .input {
    // height: 98px;
    margin: 12px 0;
    background-color: #ffffff;
    input {
      outline:none;
      -webkit-appearance: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      border: none;
      padding: 0;
    }
    > div {
      height: 49px;
      line-height: 49px;
      > span:nth-of-type(1) {
        font-weight: 600;
        font-size: 16px;
        padding: 0 12px;
      }
      > span:nth-of-type(2) {
        font-size: 16px;
        padding: 0 20px;
        font-weight: 500;
        > input {
          // height: 100%;
          height: 25px;
          line-height: 25px; //解决苹果input框光标太长问题
          border: none;
          width: 60%;
          font-size: 16px;
          &::-webkit-input-placeholder {
            font-size: 16px;
            // color: #ccc;
          }
        }
      }
    }
  }
  //主要内容
  main {
    padding: 16px 12px 6px 12px;
    background-color: #ffffff;
    > h3 {
      margin: 0;
      font-size: 16px;
      line-height: 26px;
      font-weight: bold!important;
    }
    

    .count {
      display: flex;
      justify-content: space-between;
      line-height: 26px;
      font-size: 16px;
      font-weight:500;
      margin-top: 36px;
      > div:nth-of-type(1) {
        > span {
          line-height: 26px;
        }
        > span:nth-of-type(1) {
          color: #f9591b;
          font-weight: bold!important;
        }
        > span:nth-of-type(2) {
          font-size: 14px;
          margin-left: 4px;
        }
      }
      > div:nth-of-type(2) {
        background-color: #f9591b;
        border-radius: 13px;
        color: #fff;
        font-size: 14px;
        padding: 0 15px;
        font-weight: bold!important;
      }
    }

    .btn {
      width: 100%;
      margin: 30px 0 32px 0;
      > button {
        width: 100%;
        height: 50px;
        line-height: 50px;
        border: none;
        border-radius: 60px;
        color: #999999;
        font-size: 18px;
        font-weight: 500;
        background: #eeeeee;
      }
      &.btn-active {
        color: #ffffff;
        background: linear-gradient(270deg, #f41a3c 0%, #fc740c 100%);
        border-radius: 60px;
        font-weight: 600!important;
        > button {
          color: #ffffff;
          background: linear-gradient(270deg, #f41a3c 0%, #fc740c 100%);
        }
      }
    }

    .tips {
      > h4 {
        line-height: 26px;
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 10px;
      }
      > p {
        color: #999999;
        font-size: 13px;
        line-height: 21px;
        &:not(:last-child) {
          margin-bottom: 6px;
        }
      }
    }
  }
  .van-dialog {
    width: 274px;
    border-radius: 3px;
    .van-dialog__content {
      .van-dialog__message {
        font-size: 16px;
        padding: 30px 49px;
      }
    }
  }
  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }
}

.isiOSX.recharge-platform-box {
  // padding-top: 108px;
}
</style>